import getDocumentBoundingBoxes from 'api/v2/repository/getDocumentBoundingBoxes';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';

const useBoundingBoxes = (documentId?: string) => {
  const [boundingBoxField, setBoundingBoxField] = useState<string | null>(null);

  const { data } = useQuery(
    [DocumentsRepositoryCacheKeys.DocumentBoundingBoxes, documentId],
    () => getDocumentBoundingBoxes(documentId as string),
    { enabled: !!documentId },
  );

  const boundingBox = useMemo(() => {
    if (!data || !boundingBoxField) return undefined;
    return data.find((box) => box.field_name === boundingBoxField);
  }, [data, boundingBoxField]);

  return { boundingBox, setBoundingBoxField };
};

export default useBoundingBoxes;
